module.exports = __webpack_public_path__ + "img/jtzl.9452e711.jpg";